import { ActionType } from '../action-types'
import { Actions } from '../actions'
import { PoolState } from '../../PoolContext'

interface poolTokenState {
    loading: boolean
    payload?: PoolState[]
}

const defaultPoolTokensState: poolTokenState = {
    loading: false,
    payload: []
}

const poolTokenReducer = (state: poolTokenState = defaultPoolTokensState, action: Actions): poolTokenState => {
    switch(action.type) {
        case ActionType.GET_POOL_TOKENS_REQUEST:
            return {
                loading: true
            }
        case ActionType.GET_POOL_TOKENS_FAILURE:
            return {
                loading: false,
                payload: action.error
            }
        case ActionType.GET_POOL_TOKENS_SUCCESS:
            return {
                loading: false,
                payload: action.payload
            }
        case ActionType.CLEAR_ALL:
            return {
                loading: false,
                payload: undefined
            }
        default:
            return state
    }
}

export default poolTokenReducer